var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{directives:[{name:"show",rawName:"v-show",value:(parseInt(0)),expression:"parseInt(0)"}],staticClass:"canvasAreaPreview",attrs:{"id":'canvas_'+this.uuid,"width":_vm.label.width +'px',"height":_vm.label.height+'px'}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b234396","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Canvas/Canvas.vue
// module id = 85
// module chunks = 0